// extracted by mini-css-extract-plugin
module.exports = {"group":"group--3zc04"};